var App = App || {};

App.ComponentHeaderDesktop = (function ($) {
    'use strict';

    function MegaMenu() {

        let mmActive = false;
        const mmSpeed = 300;

        const mmContainer = $(".component-header-desktop .component-header-section nav > ul");
        const mmTrigger = mmContainer.children("li").children("a, button");
        const mmItems = mmContainer.find(".component-header-section-menu").find("a");

        let mmActiveItems = [];
        let mmActiveItem = 0;

        mmItems.attr("tabindex", -1);

        mmContainer.on("mouseleave", function () {
            mmActive = false;
            MmClose(mmTrigger, mmSpeed);
        }).on("keydown", function (e) {
            if (e.keyCode === 9) {
                mmActive = false;
                MmClose($(this).children("li").children("a, button"), 1);
            }
        });

        mmTrigger.on("mouseenter", function () {
            MmOpen($(this), mmActive ? 1 : mmSpeed);
            mmActive = true;
        }).on("focus", function () {
            MmOpen($(this), 1);
            mmActive = true;
        }).on("blur", function () {
            if (mmActive === false) {
                MmClose($(this), 1);
            }
        }).on("keydown", function (e) {
            switch (e.keyCode) {
                case 39: // right arrow
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").focus();
                    break;
                case 37: // left arrow
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").focus();
                    break;
                case 40: // down arrow
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItems = [];
                    mmActiveItem = 0;
                    $(this).siblings(".component-header-section-menu").find("a:visible").each(function () { mmActiveItems.push(this); });
                    $(mmActiveItems[mmActiveItem]).focus();
                    break;
                case 27: //escape
                    e.preventDefault();
                    MmClose($(this), mmSpeed);
                    break;
            }
        });

        mmItems.on("keydown", function (e) {
            switch (e.keyCode) {
                case 39: // right arrow
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".component-header-section-menu").parent("li").next("li").children("a, button").focus();
                    break;
                case 37: // left arrow
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".component-header-section-menu").parent("li").prev("li").children("a, button").focus();
                    break;
                case 40: // down arrow
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem < mmActiveItems.length - 1 ? mmActiveItem + 1 : 0;
                    $(mmActiveItems[mmActiveItem]).focus();
                    break;
                case 38: // up arrow
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem > 0 ? mmActiveItem - 1 : mmActiveItems.length - 1;
                    $(mmActiveItems[mmActiveItem]).focus();
                    break;
                case 27: //escape
                    e.preventDefault();
                    var MenuButton = $(this).parents(".component-header-section-menu").siblings("a, button");
                    MmClose(MenuButton, megaMenuSpeed);
                    break;
            }
        });

    }

    function MmOpen(trigger, speed) {
        trigger.attr("aria-expanded", "true").siblings(".component-header-section-menu").stop().slideDown(speed);
        MmClose(trigger.parents("li").siblings("li").children("a, button"), speed);
    }

    function MmClose(trigger, speed) {
        trigger.attr("aria-expanded", "false").siblings(".component-header-section-menu").stop().slideUp(speed);
    }

    return {
        MegaMenu: MegaMenu
    };

})(jQuery);


App.ComponentHeaderMobile = (function ($) {

    function MobileMenu() {

        const offcanvas = $("#Offcanvas_Menu");
        const levels = offcanvas.find(".offcanvas-menu-levels");
        const buttons = offcanvas.find("button[data-mobilemenu]");

        offcanvas.on("hidden.bs.offcanvas", function () {
            // reset
        });

        buttons.on("click", function () {

            const currentLevel = parseInt(levels.attr("data-level"));
            const currentItem = levels.find(`.offcanvas-menu-level[data-level="${currentLevel}"]`).find(".offcanvas-menu-level-item.active");

            const nextItem = $(`#${$(this).attr("aria-controls")}`);
            const nextLevel = parseInt(nextItem.parents(".offcanvas-menu-level").attr("data-level"));

            currentItem.removeClass("active");
            nextItem.addClass("active");

            levels.attr("data-level", nextLevel);

        });

    }

    return {
        MobileMenu: MobileMenu
    };

})(jQuery);